
import api from "@/services/api.service";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

import { Group, GroupStatus } from "@/store/eventqueue/types";
import { ArmDisarmState } from "@/store/arm-disarm-area/types";

import AreaTreePicker from "@/components/form/AreaTreePicker.vue";
import { Region } from "@/store/types";
import { AreaNode } from "@/types/groups/AreaNode";

const ArmDisarm = namespace("armDisarm");

@Component({
	components: {
		"area-tree-picker": AreaTreePicker
	}
})
export default class ArmDisarmAreaSelector extends Vue {
	@ArmDisarm.State((state: ArmDisarmState) => state.currentTab) private currentTab: GroupStatus;

	@ArmDisarm.Mutation private setGroupIsArmedModalVisibility: (visible: boolean) => void;
	@ArmDisarm.Mutation private setGroupIsDisarmedModalVisibility: (visible: boolean) => void;
	@ArmDisarm.Mutation private setGroupIsOnTestModalVisibility: (visible: boolean) => void;
	@ArmDisarm.Mutation private setTreeGroupSelected: (group: Group) => void;

	@Prop({ type: Object, default: null }) private region: Region;
	@Prop({ type: Number, default: GroupStatus.All }) private currentStatus: GroupStatus;
	@Prop({ type: Object, default: () => ({}) }) private groupStatuses: { [groupId: number]: number };

	private selectedGroupId: number = null;

	@Watch("region")
	private regionChanged() {
		this.selectedGroupId = null;
	}

	/**
	 * Filters groups by the status associated with the currently selected tab.
	 */
	private filterGroupByStatus(group: AreaNode) {
		return this.currentStatus == GroupStatus.All || this.groupStatuses[group.id] == this.currentStatus;
	}

	/**
	 * Handler for when the user seelcts a group in the tree. Loads the group from the data service and, depending
	 * on that groups current status, opens the appropriate modal.
	 */
	private async onGroupSelected(groupId: number): Promise<void> {
		if (groupId == null) {
			return;
		}

		this.selectedGroupId = groupId;

		let group: Group = await api.loadGroup(groupId, this.region.url);

		if (this.currentTab == GroupStatus.All || this.currentTab === group.status) {
			this.setTreeGroupSelected(group);

			switch (group.status) {
				case GroupStatus.All:
				case GroupStatus.Armed:
				case GroupStatus.Partial: {
					this.setGroupIsArmedModalVisibility(true);
					return;
				}
				case GroupStatus.Disarmed: {
					this.setGroupIsDisarmedModalVisibility(true);
					return;
				}
				case GroupStatus.OnTest: {
					this.setGroupIsOnTestModalVisibility(true);
					return;
				}
			}
		}
	}
}
